/**
 * Labstep
 *
 * @module screens/Landing/Login/ContinueButton
 * @desc Continue Button for login modal
 */

import { Button } from 'labstep-web/core/Button';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import styles from './styles.module.scss';
import type { IButtonCircularProps } from './types';

export const ButtonCircular: React.FC<IButtonCircularProps> = ({
  icon,
  text,
  onClick,
  dataTestId,
}) => (
  <Popup
    trigger={
      <Button
        data-testid={dataTestId}
        className={styles.button}
        icon={icon}
        circular
        borderless
        onClick={onClick}
      />
    }
    content={text}
  />
);
